import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory, withRouter, useLocation } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import { downloadAPI, getAPI, patchAPI, postAPI, postFileUploadAPI, putAPI } from "../APIUtil";
import Toast, { success, error } from "../Toast";
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import AppNav from "./AppNav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sortCaret } from "../MdDataTable";
import {
  addField, checkKey, dateformatDatePicker, dateformatDatePickerYYYYMM, dateformatJPNMMDD,
  dateformatJPNYYYYMMDD, dateformatYYYY_MM, dateformatYYYY_MM_DD, dateformatYYYYMM,
  finishLoadingBtn, focusById,
  formatNumber,
  isLatestVersion,
  jumpToTopByDevice, nvl, onFocusText, onKeyDownNext, onKeyDownShortCut,
  parseDate, rpad, startLoadingBtn, toSingleByteNumberOnly
} from "../CMUtil";
import { Card, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import {
  faCalendar,
  faFileDownload,
} from "@fortawesome/free-solid-svg-icons";
import DatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";
import FormCheckLabel from "react-bootstrap/FormCheckLabel";
import MdDataTable from "../MdDataTable";
import { RoutePaths } from "./PageRoutesAuthenticated";

registerLocale('ja', ja)

export const ItemList = () => {

  const history = useHistory();
  const { search } = useLocation();
  const iniPage = useRef(true);
  const fileInputRef = useRef(null);

  const [prvURL, setPrvURL] = useState("");

  const [loading, setLoading] = useState(true);
  const [locPage, setLocPage] = useState(null);
  const [locSizePerPage, setLocSizePerPage] = useState(100);
  const [locTotalSize, setLocTotalSize] = useState(null);
  const [locSortField, setLocSortField] = useState(null);
  const [locSortOrder, setLocSortOrder] = useState(null);
  const [cntSearch, setCntSearch] = useState(0);

  const [listData, setListData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const [procId, setProcId] = useState("");
  const [cntNG, setCntNG] = useState(0);

  const amountFormatter = (cell) => cell != null && cell !== '' ? formatNumber(cell) : '';

  const ITEM_CL_LABELS = { 1: '雑誌', 2: '書籍', 3: 'ムック', 4: '開発', 9: 'その他' };
  const itemClFormatter = (cell) => ITEM_CL_LABELS[cell] ?? '';

  const ACCEPT_CD_LABELS = { '2': '販売受託', '0': '' };
  const acceptCdFormatter = (cell) => ACCEPT_CD_LABELS[cell] ?? cell ?? '';

  const flagFormatter = (cell) => cell === 1 || cell === '1' ? '有' : '';

  // 項目定義
  const columns = [
    {
      dataField: 'update_type',
      text: '種別',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "100px" },
      style: { width: "100px", maxWidth: "100px" },
      formatter: (cell) => (
        <span style={{ fontWeight: 'bold', color: cell === '追加' ? '#0d6efd' : undefined }}>{cell}</span>
      ),
    },
    {
      dataField: 'result',
      text: 'チェック結果',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "100px" },
      style: { width: "100px", maxWidth: "100px" },
      formatter: (cell, row) => row.error == null || row.error === ''
        ? <span style={{ fontWeight: 'bold', color: '#0d6efd' }}>OK</span>
        : <span style={{ fontWeight: 'bold', color: 'red' }}>NG</span>,
    },
    {
      dataField: 'item_cd',
      text: '商品',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "100px" },
      style: { width: "100px", maxWidth: "100px" },
    },
    {
      dataField: 'upd_item_name',
      text: '名称',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "250px" },
      style: { width: "250px", maxWidth: "250px" },
    },
    {
      dataField: 'upd_item_kana',
      text: 'カナ',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "250px" },
      style: { width: "250px", maxWidth: "250px" },
    },
    {
      dataField: 'upd_item_short_nm',
      text: '略称',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "150px" },
      style: { width: "150px", maxWidth: "150px" },
    },
    {
      dataField: 'upd_isbn_cd_13',
      text: 'ISBN',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "120px" },
      style: { width: "120px", maxWidth: "120px" },
    },
    {
      dataField: 'upd_item_cl',
      text: '商品区分',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "80px" },
      style: { width: "80px", maxWidth: "80px" },
      formatter: (cell) => itemClFormatter(cell),
    },
    {
      dataField: 'upd_fixed_price_1',
      text: '本体価格',
      classes: 'tbl-col text-right',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "80px", textAlign: "right" },
      style: { width: "80px", maxWidth: "80px" },
      formatter: (cell) => amountFormatter(cell),
    },
    {
      dataField: 'upd_fixed_price_including_tax1',
      text: '税込価格',
      classes: 'tbl-col text-right',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "80px", textAlign: "right" },
      style: { width: "80px", maxWidth: "80px" },
      formatter: (cell) => amountFormatter(cell),
    },
    {
      dataField: 'upd_common_magazine_cd',
      text: '共通雑誌',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "100px" },
      style: { width: "100px", maxWidth: "100px" },
    },
    {
      dataField: 'upd_Distribution_DT',
      text: '配本日',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "120px" },
      style: { width: "120px", maxWidth: "120px" },
      formatter: (cell) => dateformatYYYY_MM_DD(parseDate(cell)),
    },
    {
      dataField: 'upd_full_item_nm',
      text: '正式名',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "400px" },
      style: { width: "400px", maxWidth: "400px" },
    },
    {
      dataField: 'upd_publication_expected_dt',
      text: '刊行予定',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "120px" },
      style: { width: "120px", maxWidth: "120px" },
      formatter: (cell) => dateformatYYYY_MM_DD(parseDate(cell)),
    },
    {
      dataField: 'upd_sub_book_nm',
      text: '副書名',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "250px" },
      style: { width: "250px", maxWidth: "250px" },
    },
    {
      dataField: 'upd_sub_book_kana',
      text: '副書名カナ',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "250px" },
      style: { width: "250px", maxWidth: "250px" },
    },
    {
      dataField: 'upd_accept_cd',
      text: '受託コード',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "100px" },
      style: { width: "100px", maxWidth: "100px" },
      formatter: (cell) => acceptCdFormatter(cell),
    },
    {
      dataField: 'upd_book_form_type',
      text: '判型',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "100px" },
      style: { width: "100px", maxWidth: "100px" },
    },
    {
      dataField: 'upd_weight',
      text: '重量',
      classes: 'tbl-col text-right',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "80px", textAlign: "right" },
      style: { width: "80px", maxWidth: "80px" },
    },
    {
      dataField: 'upd_outsize_length',
      text: '外寸 縦',
      classes: 'tbl-col text-right',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "80px", textAlign: "right" },
      style: { width: "80px", maxWidth: "80px" },
    },
    {
      dataField: 'upd_outsize_width',
      text: '外寸 横',
      classes: 'tbl-col text-right',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "80px", textAlign: "right" },
      style: { width: "80px", maxWidth: "80px" },
    },
    {
      dataField: 'upd_outsize_height',
      text: '外寸 高さ',
      classes: 'tbl-col text-right',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "80px", textAlign: "right" },
      style: { width: "80px", maxWidth: "80px" },
    },
    {
      dataField: 'upd_unite_qty',
      text: '結束数',
      classes: 'tbl-col text-right',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "80px", textAlign: "right" },
      style: { width: "80px", maxWidth: "80px" },
    },
    {
      dataField: 'upd_page_qty',
      text: 'ページ数',
      classes: 'tbl-col text-right',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "80px", textAlign: "right" },
      style: { width: "80px", maxWidth: "80px" },
    },
    {
      dataField: 'upd_volume_no',
      text: '通巻№',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "100px" },
      style: { width: "100px", maxWidth: "100px" },
    },
    {
      dataField: 'upd_volume_no_magezine_cd',
      text: '誌別ｺｰﾄﾞ',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "60px" },
      style: { width: "60px", maxWidth: "60px" },
    },
    {
      dataField: 'upd_volume_no_serial_number',
      text: '誌別連番',
      classes: 'tbl-col text-right',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "60px", textAlign: "right" },
      style: { width: "60px", maxWidth: "60px" },
    },
    {
      dataField: 'upd_c_cd',
      text: 'Ｃコード',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "100px" },
      style: { width: "100px", maxWidth: "100px" },
    },
    {
      dataField: 'upd_insertion_stencil',
      text: '綴込型紙',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "100px" },
      style: { width: "100px", maxWidth: "100px" },
    },
    {
      dataField: 'upd_separate_booklet',
      text: '別冊冊子',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "100px" },
      style: { width: "100px", maxWidth: "100px" },
    },
    {
      dataField: 'upd_appendices_nm',
      text: 'その他付録',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "100px" },
      style: { width: "100px", maxWidth: "100px" },
    },
    {
      dataField: 'upd_cover_cl',
      text: 'カバー有無',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "60px" },
      style: { width: "60px", maxWidth: "60px" },
      formatter: (cell) => flagFormatter(cell),
    },
    {
      dataField: 'upd_obi_cl',
      text: '帯有無',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "60px" },
      style: { width: "60px", maxWidth: "60px" },
      formatter: (cell) => flagFormatter(cell),
    },
    {
      dataField: 'upd_binding_cl',
      text: '綴有無',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "60px" },
      style: { width: "60px", maxWidth: "60px" },
      formatter: (cell) => flagFormatter(cell),
    },
    {
      dataField: 'error',
      text: '問題',
      classes: 'tbl-col',
      sort: true, sortCaret: (order, column) => sortCaret(order, column),
      headerStyle: { width: "300px" },
      style: { width: "300px", maxWidth: "300px" },
      formatter: (cell) => cell ? <span style={{ color: 'red', fontWeight: 'bold' }}>{cell}</span> : '',
    },
  ].map(col => ({ ...col, headerStyle: { whiteSpace: "nowrap", ...(col.headerStyle || {}) }, style: { whiteSpace: "nowrap", overflow: "hidden", ...(col.style || {}) } }));

  // HOOK ////////////////////////////////////////////////////////////////////////////////////

  //初期化
  useEffect(() => {
    const init = async () => {
    }
    init();
  }, []);

  // 次・前ページ
  useEffect(() => {
    if (iniPage.current) {
      iniPage.current = false;
      return;
    }
    const update = async () => {
      await executeSearch(false);
    }
    update();
  },
    [
      locPage,
      cntSearch
    ]
  );

  // ロジック /////////////////////////////////////////////////////////////////////////////////

  const executeSearch = async (resetPage) => {
    let condition = {};
    addField(condition, "page", resetPage ? 1 : locPage);
    addField(condition, "page_size", locSizePerPage);
    addField(condition, "sort_field", locSortField);
    addField(condition, "sort_order", locSortOrder);
    const res = await getAPI("wk_item_search_view", condition);
    if (res) {
      setListData(res);
      setLocTotalSize(res.count);
    }
  };

  const onUploadCsv = async (e) => {
    const formData = new FormData();
    formData.append(
      "upload_file",
      e.target.files[0],
      e.target.files[0].name
    );
    const uploadResult = await postFileUploadAPI("wk_item_upload/", formData);

    console.log(uploadResult);
    if (uploadResult?.error) {
      error(uploadResult.error);
      fileInputRef.current.value = "";
      return;
    }
    setProcId(uploadResult?.proc_id);
    setCntNG(uploadResult.cnt_ng);
    await executeSearch(true);
    fileInputRef.current.value = "";
  };

  const onClickUploadBtn = () => {
    fileInputRef.current.click();
  };

  const onClickSaveMaster = async () => {
    await postAPI("save_wk_item_to_master/", { proc_id: procId });
    success("商品マスタを更新しました")
  };

  // 一覧イベント /////////////////////////////////////////////////////////////////////////////

  const onTableChange = (type, { page, sizePerPage, filters, sortField, sortOrder, cellEdit }) => {
    if ("pagination" === type) {
      setLocPage(page);
    }
    if ("sort" === type) {
      setLocSortField(sortField);
      setLocSortOrder(sortOrder);
    }
  }

  return (
    <>
      <AppNav />
      <div>
        <Row className="h1" style={{ maxWidth: "1400px" }}>
          <Col sm={11}>
            <h1>
              商品マスタ取込
            </h1>
          </Col>
        </Row>

        <Card className="pay-list-card-search" style={{ maxWidth: "1400px" }}>
          <Container className="container-main-search">
            <Form.Group as={Row}>
              <Col sm="6">
                商品マスタの取込ファイル（CSV）を選択してください
              </Col>
            </Form.Group>


            <Form.Group as={Row}>
              <Col sm="6">
                <div
                  id="btn-upload-csv"
                  className="btn btn-primary"
                  style={{ width: "200px" }}
                  onClick={onClickUploadBtn}
                >
                  <span>商品マスタ（CSV）取込</span>
                </div>
                <input
                  ref={fileInputRef}
                  type="file"
                  style={{ position: "fixed", top: 0, left: 0, width: "1px", height: "1px", opacity: 0, pointerEvents: "none" }}
                  onChange={onUploadCsv}
                />
              </Col>
              {procId && cntNG === 0 &&
                <Col sm="6" className="text-right">
                  <div
                    id="btn-save-master"
                    className={`btn btn-primary`}
                    style={{ width: "200px" }}
                    onClick={onClickSaveMaster}
                  >
                    <span>登録</span>
                  </div>
                </Col>

              }
            </Form.Group>
          </Container>
        </Card>
        {procId &&
          <Container className="container-main-list" style={{ maxWidth: "none", overflowX: "auto" }}>
            <MdDataTable
              keyField="id"
              listData={listData}
              columns={columns}
              loading={loading}
              onTableChange={onTableChange}
              page={locPage}
              sizePerPage={locSizePerPage}
              totalSize={locTotalSize}
              sortField={locSortField}
              sortOrder={locSortOrder}
              showPagenation={true}
            />
          </Container>
        }
      </div>
      <Toast />
    </>
  );
}

export default withRouter(ItemList);
